import { NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fmtTime } from '../lib/format';
import { useAuth } from './AuthProvider';
import { USING_MOCKS } from '../api';

export const SCREENS = [
  { path: '/', id: 'overview', title: 'обзор', hint: 'всё сразу: деньги, люди, место, активность' },
  { path: '/spaces', id: 'spaces', title: 'пространства', hint: 'кто на каком тарифе, сколько людей и места' },
  { path: '/people', id: 'people', title: 'люди', hint: 'пользователи, роли, блокировки' },
  { path: '/money', id: 'money', title: 'подписки и деньги', hint: 'триалы, конверсия, выручка, платежи' },
  { path: '/content', id: 'content', title: 'контент', hint: 'видео, хронометраж, комментарии' },
  { path: '/ops', id: 'ops', title: 'служебное', hint: 'тарифы, доступ, фоновые задачи' },
];

const RANGES = [
  [7, '7 дней'],
  [30, '30 дней'],
  [90, '90 дней'],
  [365, 'год'],
];

export default function Shell({ days, setDays, onRefresh, children }) {
  const { pathname } = useLocation();
  const { user, signOut } = useAuth();
  const screen = SCREENS.find((s) => s.path === pathname) || SCREENS[0];
  const [stamp, setStamp] = useState(() => new Date());

  useEffect(() => { setStamp(new Date()); }, [pathname, days]);

  return (
    <div id="app" className="on">
      <aside>
        <div className="brand">
          <span className="dsp">7</span><span className="spark">✦</span><span className="dsp">CUT</span>
          <span className="tag">админка</span>
        </div>
        <nav>
          {SCREENS.map((s) => (
            <NavLink key={s.id} to={s.path} end={s.path === '/'} className={({ isActive }) => (isActive ? 'active' : '')}>
              <span className="dot" />
              {s.title}
            </NavLink>
          ))}
        </nav>
        <div className="side-foot">
          {USING_MOCKS ? (
            <><b>заглушки</b>данные выдуманы: режим для разработки интерфейса без бэкенда</>
          ) : (
            <><b>живые данные</b>то же API и тот же вход, что в основном приложении</>
          )}
        </div>
      </aside>

      <main>
        <header className="top">
          <div>
            <h1>{screen.title}</h1>
            <div className="sub">{screen.hint}</div>
          </div>
          <div className="top-right">
            <button className="fresh" title="пересчитать" onClick={() => { setStamp(new Date()); onRefresh(); }}>
              <span className="live" />
              <span>данные на {fmtTime(stamp)}</span>
            </button>
            <div className="range">
              {RANGES.map(([d, label]) => (
                <button key={d} className={d === days ? 'on' : ''} onClick={() => setDays(d)}>{label}</button>
              ))}
            </div>
            <button className="whoami" onClick={signOut} title="выйти">
              <span className="av">{(user?.email || '—').slice(0, 2).toUpperCase()}</span>
              <span>{user?.email}</span>
            </button>
          </div>
        </header>
        <div className="wrap">{children}</div>
      </main>
    </div>
  );
}
